import React from "react";
import {
  ComponentDeploymentRequestListPageContent,
  ComponentDeploymentRequestListPageStateProvider,
} from ".";
import { DeploymentRequestInfomationInputDialogStateProvider } from "../dialog/deployment-request-infomation-input-dialog";

export const ComponentDeploymentRequestListPage = () => {
  return (
    <>
      <DeploymentRequestInfomationInputDialogStateProvider>
        <ComponentDeploymentRequestListPageStateProvider>
          <ComponentDeploymentRequestListPageContent />
        </ComponentDeploymentRequestListPageStateProvider>
      </DeploymentRequestInfomationInputDialogStateProvider>
    </>
  );
};
